import(/* webpackMode: "eager" */ "/opt/build/repo/apps/hestia/src/app/error.tsx");
